module.exports = __webpack_public_path__ + "4e95a1e77b291b4970dea1b4cc0f25ce.pdf";